const initialSpinnerValues =
{
    ZoneEditData: {},
    distCode: "",
    PopUpdataFlag:"",
    datagetFlag:false
}

export default function ZoneMapReducer(state = initialSpinnerValues, action) {
    switch (action.type) {
        case "ZONEDITDATA":
            return {
                ...state,
                ZoneEditData: action.payload
            };

        case "DISTRICT":
            return {
                ...state,
                distCode: action.payload
            };


            case "POPUPDATAFALG":
                return {
                    ...state,
                    PopUpdataFlag: action.payload
                };


                case "DATAGETFLAG":
                    return {
                        ...state,
                        datagetFlag: action.payload
                    };


        default:
            return state;
    }
}